require('./expireDialog.style.scss');

const tiers = [
    { tier: 'SNAPSHOT', label: 'Backup (SNAPSHOT)', targetType: 'SNAPSHOT' },
    { tier: 'BACKUP', label: 'Backup (TARGET)', targetType: 'TARGET' },
    { tier: 'COPY', label: 'Copy', targetType: 'TARGET' },
    { tier: 'ARCHIVE_DAILY', label: 'Archive - daily', targetType: 'TARGET' },
    { tier: 'ARCHIVE_WEEKLY', label: 'Archive - weekly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_MONTHLY', label: 'Archive - monthly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_YEARLY', label: 'Archive - yearly', targetType: 'TARGET' }
];

class ExpireDialogController {
    constructor($filter, $attrs) {
        this.$filter = $filter;
        this.$attrs = $attrs;
        this.modalTitle = this.$filter('translate')('expire.dialog.modal.title');
    }

    $onInit() {
        this.expireOptions = [];
        this.selectedOptions = [];
        this.closeId = { close: this.$attrs.eventId + '-close', closeIcon: this.$attrs.eventId + '-close-icon', closeTitle: this.$filter('translate')('common.toolbar.no.label') };
        this.actionButton = [
            {
                title: this.$filter('translate')('common.toolbar.yes.label'),
                action: () => this.delSelected(),
                isDisabled: () => this.isBusy || (this.expireOptions.length === 1 ? false : this.isDisabled()),
                id: this.$attrs.eventId + '-start',
                type: 'submit'
            },
        ];
    }

    onOpen() {
        this.expireOptions = [];
        this.selectedOptions = {};
        this.id = this.$attrs.eventId + '-close';
        for (let i = 0; i < this.selectedVersion.backupTiers.length; i++) {
            let filteredTiers = tiers.filter(item => this.selectedVersion.backupTiers[i].targetType === item.targetType && this.selectedVersion.backupTiers[i].backupType === item.tier && this.selectedVersion.backupTiers[i].state !== 'EXPIRED');
            if (filteredTiers.length) {
                this.setValues(filteredTiers[0], i + 1);
            }
        }
        // this.setValues()
        // this.selectedOptions = this.expireOptions;
    }

    setValues(tier, index) {
        this.expireOptions.push({
            id: index, label: tier.label, value: tier.tier, selected: true
        });
    }

    isDisabled() {
        // let val = this.selectedVersion && this.selectedVersion.backupStatus !== 'FAILED' && this.selectedVersion.backupStatus !== 'ABORTED';
        let val = this.selectedVersion && this.selectedVersion.taskStatus !== 'FAILED' && this.selectedVersion.taskStatus !== 'ABORTED';
        if (this.expireOptions.length > 0) {
            for (let x in this.selectedOptions) {
                if (this.selectedOptions[x] === true) {
                    val = false;
                }
            }
        }
        return val || Object.keys(this.selectedOptions).length === 0;
    }

    delSelected() {
        let selected = [];
        for (let x in this.selectedOptions) {
            if (this.selectedOptions[x]) {
                selected.push(x)
            }
        }
        this.onDelete({ tiers: selected.length === this.expireOptions.length ? [] : selected });
    }

    onClose() { }
}

ExpireDialogController.$inject = ['$filter', '$attrs'];

const expireDialogComponent = {
    controller: ExpireDialogController,
    template: require('./expireDialog.template.html'),
    bindings: {
        showModal: '=',
        selectedVersion: '=',
        onDelete: '&',
        disableInteraction: '<',
        hideTiers: '<?',
        isBusy: '<?'
    }
};

module.exports = expireDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/components/expireDialog/expireDialog.component.js